import { render } from "./DsAvisosImportantes.vue?vue&type=template&id=631252f9&scoped=true"
import script from "./DsAvisosImportantes.vue?vue&type=script&lang=js"
export * from "./DsAvisosImportantes.vue?vue&type=script&lang=js"

import "./DsAvisosImportantes.vue?vue&type=style&index=0&id=631252f9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-631252f9"]])

export default __exports__